export function popup(title, context, buttonText, buttonCallBack){
    privatePopup(title, context, buttonText, buttonCallBack, null, null, buttonCallBack);
}

export function popupMutiErrorMsg(title, error, buttonText, buttonCallBack){
    var html="";
    $.each(error, function(index, value){
        html = html + "<p>" + value + "</p>"
    });

    privatePopup(title, html, buttonText, buttonCallBack, null, null, buttonCallBack);
}

export function confirm(title, context, leftButtonText, leftCallBack, rightButtonText, rightButtonCallBack, hideCallBack) {
    privatePopup(title, context, leftButtonText, leftCallBack, rightButtonText, rightButtonCallBack, hideCallBack);
}

function privatePopup(title, context, leftButtonText, leftCallBack, rightButtonText, rightButtonCallBack, hideCallBack) {
    $("#popup-title").text(title);
    $("#popup-content").html(context);
    $("#popup-button-left").text(leftButtonText);
    $("#popup-button-right").text(rightButtonText);

    if($.trim(title) > ''){
        $("#popup-title").show();
    } else {
        $("#popup-title").hide();
    }

    if($.trim(rightButtonText) > '' || rightButtonCallBack) {
        $("#popup-button-right").show();
    } else {
        $("#popup-button-right").hide();
    }

    // cleanEvent
    $("#popup-modal-1").off("hide.bs.modal");
    $("#popup-button-left").off("click");
    $("#popup-button-right").off("click");

    if(rightButtonCallBack){
        $("#popup-button-right").on("click", () => {
            $("#popup-modal-1").off("hide.bs.modal");
            rightButtonCallBack();
        });
    }
    if(leftCallBack){
        $("#popup-button-left").on("click", () => {
            $("#popup-modal-1").off("hide.bs.modal");
            leftCallBack();
        });
    }
    if(hideCallBack){
        $("#popup-modal-1").on("hide.bs.modal", hideCallBack);
    }

    $("#popup-modal-1").modal();
}

$.ajaxSetup({
  error: function(res){
    popup("提示", "系統錯誤", "確定");
  }
});